import api from "Api";
import routes from "constants/ApiRoutesConstants";

const GetUsersList = async (params) => {
  const response = await api.get(routes.GET_USERS_LIST, { params: params });
  return response;
};

const PatchUserData = async (userId, data) => {
  try {
    const response = await api.patch(
      `${routes.PATCH_USER_DETAILS}${userId}`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export { GetUsersList, PatchUserData };
